export const UPLOAD_MAX_SIZE = 104857600;

export const INITIAL_OPTIONS = {
  maxFilesSize: 2e9,
  maxFilesSizeErrorText: 'Превышена максимальная сумма размера файлов - 2Гб',
};

export const UPLOAD_ATTACHMENT_ENDPOINT = '/api/upload/attachment/';

export const SIZE_LIMIT_ERROR_MESSAGE =
  'Произошла ошибка при загрузке файла. Размер файла превышает допустимый лимит';
export const UNHANDLED_ERROR_MESSAGE = 'Произошла ошибка при загрузке файла.';

export const MIME_EXTENSIONS_MAP: Record<string, string> = {
  'vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  msword: 'doc',
  'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'vnd.ms-excel': 'xls',
  'vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'vnd.ms-powerpoint': 'ppt',
  plain: 'txt',
};
